import { Base } from '@wilson/base';
import type { MobileSettingsAbsenceCategory } from '../absences/absenceCategory';
import type { OrganizationalUnit } from '../organizational-units/organizationalUnit';

export interface MobileSetting extends Base {
  allowSpacesBetweenActivities: boolean;
  requireRestPeriodBetweenShifts: boolean;
  checkBreakRegulations: boolean;
  allowAutomaticInterruptionActivity: boolean;
  shiftStartBeforePlannedInMinutes: number;
  requireAgreementForShiftSubmission: boolean;
  allowAbsenceCreation: boolean;
  colleagueShiftVisibility: MobileSettingColleagueShiftVisibilityEnum;
  requireSickLeaveAttachment: boolean;
  organizationalUnit?: OrganizationalUnit;
  organizationalUnitId: OrganizationalUnit['id'];
  absenceCategoryIds: string[];
  mobileSettingAbsenceCategories?: MobileSettingsAbsenceCategory[];
  autoShiftReporting: boolean;
  minBreakTimeInMinutesViolation: MobileSettingMinBreakTimeInMinutesViolation | null;
  allowUsersToWithdrawShiftSubmissions: boolean;
  canDeclineShift: boolean | null;
  requireDeclineReasons: boolean | null;
  shiftDeclineReasons: string[];
  trackShiftLastSeen: boolean;
  canConfirmShift: boolean;
  showHomeWidgetTimeWorkedMonthlyTarget: boolean;
  showHomeWidgetBalanceOvertimeAccount: boolean;
  showDashboard: boolean;
  showDashboardWorkingTime: boolean;
  showDashboardOvertimeAndOtherAccounts: boolean;
  showDashboardPayPremiums: boolean;
  showDashboardOther: boolean;
  showDashboardTimesheet: boolean;
}

export enum MobileSettingMinBreakTimeInMinutesViolation {
  AllowedWithoutComment = 'allowed-without-comment',
  AllowedWithComment = 'allowed-with-comment',
  NotAllowed = 'not-allowed',
}

export enum MobileSettingColleagueShiftVisibilityEnum {
  None = 'none',
  FullAccess = 'full-access',
  ProjectOnly = 'project-only',
}
